import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import SupportTemplateUpdateModalSF from './SupportTemplateUpdateModalSF'
import IconUploadButtonUI from '../../../widgets/action/IconUploadButtonUI'


//import './SupportTemplateList.css'

const SupportTemplateListUI = ({ context, rootTemplate, onRefreshClick, templateList,
  updateMode, onUpdateClick, onCancelUpdateClick, selectedTemplate, onMoveUpSubmit, onMoveUpMode }) =>
  <div className='su_doc'>
    <CardUI title='Templates' className='g_m_bottom_100'>
      {
        rootTemplate &&
        <TreeNodeUI node={rootTemplate} title={rootTemplate.title} onUpdateClick={onUpdateClick} onMoveUpSubmit={onMoveUpSubmit} />
      }
    </CardUI>

    <SupportTemplateUpdateModalSF context={context}
      selectedTemplate={selectedTemplate} updateMode={updateMode} templateList={templateList}
      onCancelClick={onCancelUpdateClick} onRefreshClick={onRefreshClick} onMoveUpMode={onMoveUpMode}
    />
  </div>

const TreeNodeUI = ({ node, title, onUpdateClick, onMoveUpSubmit }) =>
  <div>
    {
      node.title !== 'ROOT' &&
      <span className='g_m_left_100 g_flex_v'>
        <span><b>{node.title}</b>
          <span className='g_m_left_50 g_muted icon icon-pencil g_cursor_pointer'
            onClick={onUpdateClick} data-template-id={node.supportTemplateId} />
          <span className='g_m_left_50 g_muted icon icon-angle-double-up g_cursor_pointer'
            onClick={onMoveUpSubmit} data-template-id={node.supportTemplateId} />
          <span className='g_ultra_muted g_m_left_50'>{node.supportTemplateId}</span>
        </span>
        <span className='g_flex_v'>
          <span>{node.body}</span>
          <span>{node.message}</span>
        </span>
      </span>
    }
    {
      node.supportTemplateList && node.supportTemplateList.length > 0 &&
      <ul>
        {
          node.supportTemplateList.map(childNode => (
            <li key={childNode.fileId}>
              <TreeNodeUI node={childNode} title={title} onUpdateClick={onUpdateClick} onMoveUpSubmit={onMoveUpSubmit} />
            </li>
          ))
        }
      </ul>
    }
  </div>

export default SupportTemplateListUI
